import React from "react";
import "../../styles.css";
import { useState, useEffect } from "react";
import StarRating from "../UserPatientScreen/StarRating";
import {
  useActionData,
  useLocation,
  Link,
  useNavigate,
} from "react-router-dom";
import { API_IP } from "../../global_variables";
import { axiosReqConfig } from "../../functions/axiosRequest";
import { Calendar } from "react-multi-date-picker";
import PromptModal from "../ReuseComponent/PromptModal";
import { Checkbox } from "@mui/material";
import { sub } from "date-fns";
import { createChannel, registerChannel } from "../Amity/AmityProvider.ts";

const hourSlots = [
  { label: "07:00 - 08:00", start: "07:00", end: "08:00" },
  { label: "08:00 - 09:00", start: "08:00", end: "09:00" },
  { label: "09:00 - 10:00", start: "09:00", end: "10:00" },
  { label: "10:00 - 11:00", start: "10:00", end: "11:00" },
  { label: "11:00 - 12:00", start: "11:00", end: "12:00" },
  { label: "12:00 - 13:00", start: "12:00", end: "13:00" },
  { label: "13:00 - 14:00", start: "13:00", end: "14:00" },
  { label: "14:00 - 15:00", start: "14:00", end: "15:00" },
  { label: "15:00 - 16:00", start: "15:00", end: "16:00" },
  { label: "16:00 - 17:00", start: "16:00", end: "17:00" },
];

const StartTimeModal = ({
  title,
  showModal,
  handleClose,
  selectedTime,
  selectedStartTime,
  selectedEndTime,
  setSelectedTime,
  onConfirm,
}) => {
  const [alertContent, setAlertContent] = useState("");
  const [isAlertVisible, setIsAlertVisible] = useState(false);
  const [selectedTimeInModal, setSelectedTimeInModal] = useState(selectedTime);

  const toggleAlert = () => setIsAlertVisible(!isAlertVisible);

  const timeSlots = [
    "07:00",
    "08:00",
    "09:00",
    "10:00",
    "11:00",
    "12:00",
    "13:00",
    "14:00",
    "15:00",
    "16:00",
    "17:00",
  ];

  const handleTimeSelect = (time) => {
    if (
      title == "Start Time" &&
      parseInt(time) >= parseInt(selectedEndTime) - 1
    ) {
      toggleAlert();
      setAlertContent("Make sure you select more than 2 hour");
    } else if (
      title == "End Time" &&
      parseInt(time) <= parseInt(selectedStartTime) + 1
    ) {
      toggleAlert();
      setAlertContent("Make sure you select more than 2 hour");
    } else {
      setSelectedTimeInModal(time);
    }
  };
  const closeConfirm = () => {
    onConfirm(selectedTimeInModal);
    setSelectedTime(selectedTimeInModal);
    handleClose();
  };
  if (!showModal) {
    return null; // Return null if the modal is not open
  }

  return (
    <div className="startTime-modal-overlay" onClick={handleClose}>
      <div
        className="startTime-modal-content"
        onClick={(e) => e.stopPropagation()}
      >
        <PromptModal
          title={alertContent}
          type="alert"
          showModal={isAlertVisible}
          handleClose={toggleAlert}
        />
        <div className="startTime-modal-header">
          <h2>Select a {title}</h2>
          <button className="startTime-close-button" onClick={handleClose}>
            &times;
          </button>
        </div>
        <div className="startTime-modal-body">
          <ul className="startTime-time-list">
            {timeSlots.map((time, index) => (
              <li
                key={index}
                className={`startTime-time-slot ${
                  selectedTimeInModal === time ? "startTime-selected" : ""
                }`}
                onClick={() => handleTimeSelect(time)}
              >
                {time}
              </li>
            ))}
          </ul>
        </div>
        <div className="startTime-modal-footer">
          <button className="startTime-submit-button" onClick={closeConfirm}>
            Confirm ({selectedTimeInModal || "No time selected"})
          </button>
        </div>
      </div>
    </div>
  );
};

const SubUserDataModal = ({
  title,
  userData,
  showModal,
  requestDataOnClose,
  handleClose,
  selectedValue,
  setSelectedValue,
}) => {
  const [selectedValueInModal, setSelectedValueInModal] =
    useState(selectedValue);
  const [isMoreInfoVisible, setIsMoreInfoVisible] = useState(false);
  const [sDatesWOHour, setSDatesWOHour] = useState([]);
  const handleSelectValue = (value) => {
    setSelectedValueInModal(value);
  };
  const navigate = useNavigate();
  const toggleMoreInfoModal = () => setIsMoreInfoVisible(true);

  if (!showModal) {
    return null; // Return null if the modal is not open
  }
  const onCloseClick = async () => {
    if (title == "Patient" || title == "Provider" || title == "Service") {
      if (selectedValueInModal !== null) {
        await requestDataOnClose(title, selectedValueInModal);
      }
    } else if (title == "Calendar") {
      const updatedDetailedDates = sDatesWOHour.map((date) => {
        const formatedDate = date.format("YYYY-MM-DD");
        return {
          day: formatedDate,
          startTime: "07:00", // Mặc định ô đầu tiên
          endTime: "08:00",
          hours: 1,
        };
      });
      updatedDetailedDates.sort((a, b) => new Date(a.date) - new Date(b.date));
      setSelectedValue(updatedDetailedDates);
    }
    handleClose();
  };

  const renderListData = () => {
    try {
      switch (title) {
        case "Patient":
          return (
            <>
              {userData.patients.map((value, index) => (
                <li
                  key={index}
                  className={`startTime-time-slot ${
                    selectedValueInModal !== null &&
                    selectedValueInModal.patient_id === value.patient_id
                      ? "startTime-selected"
                      : ""
                  }`}
                  onClick={() => handleSelectValue(value)}
                >
                  {value.first_name} {value.last_name}
                </li>
              ))}
            </>
          );
        case "Provider":
          return (
            <>
              {userData.providers.map((value, index) => {
                return (
                  <li
                    key={index}
                    id={`${value.provider_name}-${value.provider_id}`}
                    className={`startTime-time-slot calendar-provider-item ${
                      selectedValueInModal !== null &&
                      selectedValueInModal.provider_id === value.provider_id
                        ? "startTime-selected"
                        : ""
                    }`}
                    onClick={() => handleSelectValue(value)}
                  >
                    <div>{value.provider_name}</div>
                    <button
                      className="calendar-provider-info-button"
                      onClick={toggleMoreInfoModal}
                    >
                      <img
                        src={require("../../images/more_info_icon.png")}
                        alt="Clock icon"
                        className="calendar-provider-info-icon"
                      />
                    </button>
                  </li>
                );
              })}
            </>
          );
        case "Service":
          return (
            <>
              {userData.map((value, index) => (
                <li
                  key={index}
                  className={`startTime-time-slot ${
                    selectedValueInModal !== null &&
                    selectedValueInModal.care_service_name ===
                      value.care_service_name
                      ? "startTime-selected"
                      : ""
                  }`}
                  onClick={() => handleSelectValue(value)}
                >
                  {value.care_service_name}
                </li>
              ))}
              {userData.length === 0 ? (
                <div className="no-data-message">
                  No services available near this member location
                </div>
              ) : (
                <></>
              )}
            </>
          );
        case "Calendar":
          return (
            <div className="multiple-calendar-content">
              <h2>Select Multiple Dates</h2>
              <div className="multiple-calendar-body">
                <Calendar
                  multiple
                  value={sDatesWOHour}
                  onChange={setSDatesWOHour} // Update selected dates
                  mapDays={({ date }) => {
                    // Disable all dates before today
                    if (date < new Date().setHours(0, 0, 0, 0)) {
                      return {
                        disabled: true,
                        style: { color: "#ccc" }, // Grey out past dates
                      };
                    }
                  }}
                />
              </div>

              <p>
                Selected Dates:{" "}
                {sDatesWOHour.length > 0
                  ? sDatesWOHour
                      .map((date) => date.format("YYYY-MM-DD"))
                      .join(", ")
                  : "None"}
              </p>
            </div>
          );
        default:
          return <></>;
      }
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <div className="startTime-modal-overlay" onClick={handleClose}>
      <div
        className="startTime-modal-content"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="startTime-modal-header">
          <h2>{title !== "Patient" ? title : "Member"}</h2>{" "}
          {/* temp Adjusted title */}
          <button className="startTime-close-button" onClick={handleClose}>
            &times;
          </button>
        </div>
        <div className="startTime-modal-body">
          <ul className="startTime-time-list">{renderListData()}</ul>
        </div>
        <div className="startTime-modal-footer">
          <button className="startTime-submit-button" onClick={onCloseClick}>
            Confirm
          </button>
        </div>
      </div>
      {title === "Provider" ? (
        <div
          className={`provider-info-side-bar ${
            isMoreInfoVisible ? "open" : ""
          }`}
        >
          <div className="provider-info-bar-image-container">
            <img
              src={
                selectedValueInModal?.img_url ||
                require("../../images/avatar_placeholder.png")
              }
              className="provider-info-bar-image"
            />
          </div>
          <div className="provider-info-bar-content">
            <h1>
              {selectedValueInModal?.provider_name || "No provider selected"}
            </h1>
            {selectedValueInModal?.provider_name ==
            "💡Choose A Provider For Me💡" ? (
              <></>
            ) : (
              <>
                <h2>{selectedValueInModal?.title || ""}</h2>
                <h2>
                  Experience: {selectedValueInModal?.experience || ""}+ years
                </h2>
                <h4>
                  Open Hour: {selectedValueInModal?.opening_hour || ""} -{" "}
                  {selectedValueInModal?.closing_hour || ""}
                </h4>
                <StarRating rating={4} maxStars={5} />
                <div className="provider-info-bar-footer">
                  <button
                    onClick={() => {
                      navigate(`/CareProviderProfile`, {
                        state: {
                          data: selectedValueInModal,
                        },
                      });
                    }}
                  >
                    Learn More
                  </button>
                </div>
              </>
            )}
          </div>
        </div>
      ) : (
        <></>
      )}
    </div>
  );
};
const DateItem = ({ date, index, providerId, isDayDisabled }) => {
  const [selectedIndices, setSelectedIndices] = useState([]);
  const [disabledSlots, setDisabledSlots] = useState([]);
  const [isFullDayBusy, setIsFullDayBusy] = useState(isDayDisabled || false);

  useEffect(() => {
    const fetchDisabledSlots = async () => {
      if (!providerId || !date.day) return;
      try {
        const response = await axiosReqConfig(
          `${API_IP}/api/providers/availability?provider_id=${providerId}&date=${date.day}`,
          "GET"
        );

        const busySlots = response || [];
        setDisabledSlots(busySlots);

        if (busySlots.length >= hourSlots.length) {
          setIsFullDayBusy(true);
        }
      } catch (error) {
        console.error("Error fetching availability:", error);
      }
    };
    fetchDisabledSlots();
  }, [date.day, providerId]);

  const handleSelectSlot = (clickedIndex) => {
    if (isFullDayBusy) return;

    const clickedSlot = hourSlots[clickedIndex];
    const isBusy = disabledSlots.some(
      (s) => s.start_time && s.start_time.startsWith(clickedSlot.start)
    );
    if (isBusy) return;
    if (disabledSlots.includes(clickedSlot.start)) return;

    let newIndices = [];
    if (selectedIndices.length === 0) {
      newIndices = [clickedIndex];
    } else if (
      selectedIndices.length === 1 &&
      selectedIndices[0] === clickedIndex
    ) {
      newIndices = [];
    } else {
      const start = Math.min(selectedIndices[0], clickedIndex);
      const end = Math.max(selectedIndices[0], clickedIndex);

      let hasDisabledInRange = false;
      for (let i = start; i <= end; i++) {
        if (disabledSlots.includes(hourSlots[i].start)) {
          hasDisabledInRange = true;
          break;
        }
      }

      if (hasDisabledInRange) {
        newIndices = [clickedIndex];
      } else {
        for (let i = start; i <= end; i++) {
          newIndices.push(i);
        }
      }
    }

    setSelectedIndices(newIndices);

    if (newIndices.length > 0) {
      const firstSlot = hourSlots[newIndices[0]];
      const lastSlot = hourSlots[newIndices[newIndices.length - 1]];
      date.startTime = firstSlot.start;
      date.endTime = lastSlot.end;
      date.hours = newIndices.length;
    } else {
      date.startTime = null;
      date.endTime = null;
      date.hours = 0;
    }
  };

  return (
    <div
      className="calendar-date-item"
      style={{
        marginBottom: "25px",
        padding: "10px",
        border: isFullDayBusy ? "1px solid #ff4d4f" : "1px solid #f0f0f0",
        borderRadius: "8px",
        backgroundColor: isFullDayBusy ? "#fff1f0" : "white",
        opacity: isFullDayBusy ? 0.6 : 1,
      }}
    >
      <div
        style={{
          marginBottom: "12px",
          fontWeight: "bold",
          display: "flex",
          alignItems: "center",
          color: isFullDayBusy ? "#ff4d4f" : "#333",
        }}
      >
        <img
          src={require("../../images/calendar_icon.png")}
          style={{
            width: 16,
            marginRight: 8,
            opacity: isFullDayBusy ? 0.5 : 1,
          }}
          alt="date"
        />
        <span>
          {date.day} {isFullDayBusy ? "(Unavailable)" : ""}
        </span>
        {date.hours > 0 && !isFullDayBusy && (
          <span
            style={{ marginLeft: "auto", color: "#fcc201", fontSize: "12px" }}
          >
            ({date.hours} hours selected)
          </span>
        )}
      </div>

      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(3, 1fr)",
          gap: "8px",
        }}
      >
        {hourSlots.map((slot, idx) => {
          const isSelected = selectedIndices.includes(idx);
          const isDisabled =
            isFullDayBusy ||
            disabledSlots.some(
              (s) => s.start_time && s.start_time.startsWith(slot.start)
            );

          return (
            <button
              key={idx}
              disabled={isDisabled}
              onClick={() => handleSelectSlot(idx)}
              style={{
                padding: "10px 4px",
                fontSize: "12px",
                cursor: isDisabled ? "not-allowed" : "pointer",
                borderRadius: "6px",
                border: isDisabled ? "1px solid #d9d9d9" : "1px solid #fcc201",
                backgroundColor: isDisabled
                  ? "#f5f5f5"
                  : isSelected
                  ? "#fcc201"
                  : "white",
                color: isDisabled ? "#bfbfbf" : isSelected ? "white" : "#333",
                fontWeight: isSelected ? "bold" : "normal",
                textDecoration: isDisabled ? "line-through" : "none",
                transition: "all 0.1s ease",
              }}
            >
              {slot.label}
            </button>
          );
        })}
      </div>
    </div>
  );
};

const SubServiceItem = ({ service, setSelectedSubService }) => {
  const [checkItem, setCheckItem] = useState(false);
  const handleCheckboxChange = (e) => {
    const isChecked = e.target.checked;
    setCheckItem(!checkItem);
    if (isChecked) {
      setSelectedSubService((prev) => [...prev, service.id]);
    } else {
      setSelectedSubService((prev) =>
        prev.filter((item) => item !== service.id)
      );
    }
  };

  return (
    <div className="Preferences-checkbox-item">
      <input
        type="checkbox"
        name={`${service.name}`}
        checked={checkItem}
        onChange={handleCheckboxChange}
        className="Preferences-checkbox"
      />
      {service.name}
    </div>
  );
};
const Modal = ({
  showModal,
  handleClose,
  preSelectedProvider,
  preSelectedService,
  toggleRefresh,
  setSelectedSection,
}) => {
  const [selectedDates, setSelectedDates] = useState([]);
  const [textValue, setTextValue] = useState(""); // State to hold text input
  const [isPatientVisible, setIsPatientVisible] = useState(false);
  const [isProviderVisible, setIsProviderVisible] = useState(false);
  const [isServiceVisible, setIsServiceVisible] = useState(false);
  const [isCalendarVisible, setIsCalendarVisible] = useState(false);
  const [selectedPatient, setSelectedPatient] = useState(null);
  const [alertHandleClose, setAlertHandleClose] = useState(null);
  const [selectedProvider, setSelectedProvider] = useState(
    preSelectedProvider || null
  );
  const [selectedSubService, setSelectedSubService] = useState([]);
  const [alertConsent, setAlertConsent] = useState(null);
  const [alertType, setAlertType] = useState("");
  const [selectedService, setSelectedService] = useState(
    preSelectedService || null
  );
  const [subService, setSubService] = useState(
    preSelectedService ? preSelectedService.sub_services : []
  );
  const [userProviderData, setUserProviderData] = useState([]);
  const defaultProviderData = {
    provider_id: null,
    provider_name: `💡Choose A Provider For Me💡`,
  };
  const [userSerivceData, setUserServiceData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [alertContent, setAlertContent] = useState("");
  const [isAlertVisible, setIsAlertVisible] = useState(false);
  const [patientData, setPatientData] = useState([]);
  const [patientOpVisible, setPatientOpVisible] = useState(false);
  const navigate = useNavigate();

  const toggleAlert = () => setIsAlertVisible(!isAlertVisible);
  const toggleServiceModal = () => setIsServiceVisible(!isServiceVisible);
  const toggleProviderModal = () => setIsProviderVisible(!isProviderVisible);
  const togglePatientModal = () => setIsPatientVisible(!isPatientVisible);
  const toggleCalendarModal = () => setIsCalendarVisible(!isCalendarVisible);
  const handleTextChange = (event) => {
    setTextValue(event.target.value); // Update state when text area changes
  };
  // const handleDateChange = (date) => {
  //   setSelectedDate(date);
  //   setIsCalendarModalVisible(false); // Hide calendar sub-modal after selecting a date
  // };

  const requestDataOnClose = async (title, selectedValue) => {
    try {
      if (title == "Patient") {
        const city = selectedValue.city || "Victoria";
        const country = selectedValue.country || "Canada";
        if (preSelectedProvider == null) {
          setSelectedProvider(null);
          const data = await axiosReqConfig(
            `${API_IP}/api/service?city=${city}&country=${country}`,
            "get",
            []
          );
          setUserServiceData(data);
        } else {
          const data = await axiosReqConfig(
            `${API_IP}/api/service/${preSelectedProvider.provider_id}`,
            "get",
            []
          );
          setUserServiceData(data);
        }

        setSelectedPatient(selectedValue);

        if (preSelectedService == null) {
          setSelectedService(null);
        } else {
          const providerData = await axiosReqConfig(
            `${API_IP}/api/provider?city=${
              selectedValue.city || "Victoria"
            }&country=${selectedValue.country || "Canada"}&filter=${
              preSelectedService.care_service_name
            }`,
            "get",
            []
          );
          providerData.providers.push(defaultProviderData);
          setUserProviderData(providerData);
          if (preSelectedProvider === null) {
            setSelectedProvider(null);
          }
        }
      } else if (title == "Service") {
        try {
          const providerData = await axiosReqConfig(
            `${API_IP}/api/provider?city=${selectedPatient.city}&country=${selectedPatient.country}&filter=${selectedValue.care_service_name}`,
            "get",
            []
          );
          setSelectedService(selectedValue);
          console.log(providerData);
          providerData.providers.push(defaultProviderData);
          setUserProviderData(providerData);
          setSubService(selectedValue.sub_services);
          console.log(selectedValue.sub_services);
          if (preSelectedProvider === null) {
            setSelectedProvider(null);
          }
        } catch (e) {
          throw e;
        }
      } else if (title == "Provider") {
        setSelectedProvider(selectedValue);
      }
    } catch (error) {
      alert(`${error}`);
    }
  };

  const resetModal = () => {
    setSelectedPatient(null);
    setSelectedDates([]);
    setSelectedSubService([]);
    setSubService([]);
    if (preSelectedService == null) {
      setSelectedService(null);
    }
    if (preSelectedProvider == null) {
      setSelectedProvider(null);
    }
  };
  const confirmSuccessfulRequest = () => {
    switch (alertHandleClose) {
      case "close":
        toggleAlert();
        break;
      case "moveToUserCenter":
        toggleAlert();
        resetModal();
        handleClose();
        if (preSelectedProvider != null || preSelectedService != null) {
          moveToNextPage();
        }
        break;
      case "moveToPatientPage":
        moveToNextPage();
        moveToPatientPage();
        break;
      default:
        toggleAlert();
        resetModal();
        handleClose();
        break;
    }
  };

  const moveToNextPage = (screen) => {
    navigate("/UserHome");
  };

  const moveToPatientPage = () => {
    setSelectedSection("Patient");
  };

  const sendTheRequestToProvider = async () => {
    try {
      console.log(selectedSubService);
      if (
        selectedDates.length == 0 ||
        selectedPatient == null ||
        selectedProvider == null ||
        selectedService == null ||
        selectedSubService.length == 0
      ) {
        setIsAlertVisible(!isAlertVisible);
        setAlertType("alert");
        setAlertHandleClose("close");
        setAlertContent(
          `Please select a patient, a provider, a service, a sub service and dates that you are desired.`
        );

        return;
      }
      setIsLoading(true);
      console.log(selectedProvider.provider_id);
      const sendRequestData = await axiosReqConfig(
        `${API_IP}/api/booking`,
        "post",
        {
          providerRequest: selectedProvider.provider_id,
          serviceRequest: selectedService.care_service_name,
          patientId: selectedPatient.patient_id,
          startDate: selectedDates[0].day,
          endDate: selectedDates[selectedDates.length - 1].day,
          dates: selectedDates,
          subServices: selectedSubService,
          teamRequest: null,
        }
      );
      if (selectedProvider.provider_id !== null) {
        const newChannel = await createChannel(sendRequestData.amityUsers);
        await registerChannel(newChannel.channelId, sendRequestData.amityUsers);
      }

      toggleRefresh();
      resetModal();
      setTimeout(() => {
        setAlertType("alert");
        setAlertHandleClose("moveToUserCenter");
        if (preSelectedProvider != null || preSelectedService != null) {
          setAlertContent(
            "Your request has been successfully sent. You will get a response within 24 hours."
          );
        } else {
          setAlertContent("Your request has successfully sent!");
        }
        setIsAlertVisible(true);
        setIsLoading(false);
      }, 2000);
    } catch (error) {
      setIsAlertVisible(!isAlertVisible);
      setAlertContent(`Error try late: ${error}`);
    }
  };

  const onModalClose = () => {
    resetModal();
    handleClose();
  };
  const getPatientData = async () => {
    const data = await axiosReqConfig(`${API_IP}/api/patients`, "get", []);
    if (data.patients.length == 0) {
      setIsAlertVisible(true);
      setAlertType("alert");

      setAlertContent(
        "It appears you don't have a patient profile set up yet. You'll be taken to the Patients page to create your first profile."
      );
      setAlertHandleClose("moveToPatientPage");
    } else {
      setPatientOpVisible(true);
      setPatientData(data);
    }
  };

  useEffect(() => {
    let isMounted = true;
    if (isMounted) {
      getPatientData();
    }
    return () => {
      isMounted = false;
    };
  }, []);

  if (!showModal) {
    return null; // If modal is not active, return null
  }
  return (
    <>
      <div
        className="calendar-modal-overlay"
        onClick={() => {
          !isLoading ? onModalClose() : <></>;
        }}
      >
        {!isLoading ? (
          <div
            className="calendar-modal-content"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="calendar-modal-header">
              <h2>Request A Service </h2>
              <button className="calendar-close-button" onClick={onModalClose}>
                &times;
              </button>
            </div>
            <div className="calendar-modal-body">
              <div className="calendar-modal-image-placeholder">
                <img
                  src={require("../../images/placeholder_calendar_photo.jpg")}
                  alt="Clock icon"
                  className="calendar-modal-image"
                />
              </div>
              <div className="calendar-modal-form">
                <div className="calendar-modal-options">
                  <div>
                    <button
                      onClick={togglePatientModal}
                      className={`calendar-modal-providerButton ${
                        selectedPatient !== null
                          ? "calendar-selected-button"
                          : ""
                      } ${patientOpVisible == false ? "greyed-out" : ""}`}
                      disabled={!patientOpVisible}
                    >
                      <img
                        src={require("../../images/patient_icon.png")}
                        alt="Clock icon"
                        className="calendar-patient-icon"
                      />
                      {selectedPatient !== null ? (
                        <>
                          {selectedPatient.first_name}{" "}
                          {selectedPatient.last_name}
                          <img
                            src={require("../../images/tick_icon.png")}
                            alt="Clock icon"
                            className="calendar-time-icon"
                          />
                        </>
                      ) : (
                        <>
                          Choose a Member <div></div>
                        </>
                      )}
                    </button>
                  </div>
                  <div>
                    <button
                      onClick={toggleServiceModal}
                      className={`calendar-modal-providerButton ${
                        selectedPatient == null && preSelectedService == null
                          ? "greyed-out"
                          : ""
                      } 
                      ${
                        selectedService !== null
                          ? "calendar-selected-button"
                          : ""
                      }`}
                      disabled={
                        selectedPatient == null || preSelectedService != null
                      }
                    >
                      <img
                        src={require("../../images/service_icon.png")}
                        alt="Clock icon"
                        className="calendar-patient-icon"
                      />
                      {selectedService !== null ? (
                        <>
                          {selectedService.care_service_name}
                          <img
                            src={require("../../images/tick_icon.png")}
                            alt="Clock icon"
                            className="calendar-time-icon"
                          />
                        </>
                      ) : (
                        <>
                          Choose A Service <div></div>
                        </>
                      )}
                    </button>
                  </div>
                  <div>
                    <button
                      onClick={toggleProviderModal}
                      className={`calendar-modal-providerButton 
                        ${
                          selectedService == null && preSelectedProvider == null
                            ? "greyed-out"
                            : ""
                        } 
                        ${
                          selectedProvider !== null
                            ? `calendar-selected-button`
                            : ""
                        }`}
                      disabled={
                        selectedService == null || preSelectedProvider != null
                      }
                    >
                      <img
                        src={require("../../images/provider_icon.png")}
                        alt="Clock icon"
                        className="calendar-patient-icon"
                      />
                      {selectedProvider !== null ? (
                        <>
                          {selectedProvider.provider_name}
                          <img
                            src={require("../../images/tick_icon.png")}
                            alt="Clock icon"
                            className="calendar-time-icon"
                          />
                        </>
                      ) : (
                        <>
                          Choose a Provider <div></div>
                        </>
                      )}
                    </button>
                  </div>
                  {subService.length !== 0 ? (
                    <div className="calendar-sub-service-container">
                      {subService.map((service, index) => {
                        return (
                          <SubServiceItem
                            key={index}
                            service={service}
                            setSelectedSubService={setSelectedSubService}
                          />
                        );
                      })}
                    </div>
                  ) : (
                    <></>
                  )}

                  <div className="calendar-list-dates-container">
                    {selectedDates.map((date, index) => {
                      return (
                        <DateItem
                          key={index}
                          date={date}
                          index={index}
                          providerId={selectedProvider?.provider_id}
                        />
                      );
                    })}
                  </div>
                  <div>
                    <button onClick={toggleCalendarModal} className={``}>
                      <img
                        src={require("../../images/provider_icon.png")}
                        alt="Clock icon"
                        className="calendar-patient-icon"
                      />
                      Add/Remove dates <div></div>
                    </button>
                  </div>
                  <div>
                    <textarea
                      value={textValue} // Bind the text area's value to the component's state
                      onChange={handleTextChange} // Handle change event
                      placeholder="Add Notes"
                      rows="3"
                      style={{
                        padding: "10px",
                        fontSize: "16px",
                        borderRadius: "8px",
                        width: "96%",
                      }}
                    />
                  </div>
                </div>
                <div className="calendar-modal-footer">
                  <button
                    className="calendar-cancel-button"
                    onClick={handleClose}
                  >
                    Cancel
                  </button>
                  <button
                    className="calendar-request-button"
                    onClick={sendTheRequestToProvider}
                  >
                    Request Service
                  </button>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <>
            <img
              src={require("../../images/loading_icon.gif")}
              alt="Clock icon"
            />
          </>
        )}
      </div>
      <PromptModal
        title={alertContent}
        type={alertType}
        showModal={isAlertVisible}
        handleClose={confirmSuccessfulRequest}
        handleConsent={alertConsent}
        isLoading={isLoading}
      />
      <SubUserDataModal
        title="Patient"
        userData={patientData}
        showModal={isPatientVisible}
        requestDataOnClose={requestDataOnClose}
        handleClose={togglePatientModal}
        selectedValue={selectedPatient}
        setSelectedValue={setSelectedPatient}
      />
      <SubUserDataModal
        title="Service"
        userData={userSerivceData}
        showModal={isServiceVisible}
        requestDataOnClose={requestDataOnClose}
        handleClose={toggleServiceModal}
        selectedValue={selectedService}
        setSelectedValue={setSelectedService}
      />
      <SubUserDataModal
        title="Provider"
        userData={userProviderData}
        showModal={isProviderVisible}
        requestDataOnClose={requestDataOnClose}
        handleClose={toggleProviderModal}
        selectedValue={selectedProvider}
        setSelectedValue={setSelectedProvider}
      />
      <SubUserDataModal
        title="Calendar"
        userData={userProviderData}
        showModal={isCalendarVisible}
        requestDataOnClose={requestDataOnClose}
        handleClose={toggleCalendarModal}
        selectedValue={selectedDates}
        setSelectedValue={setSelectedDates}
      />
    </>
  );
};

export default Modal;
